/* eslint-disable react-refresh/only-export-components */
// @refresh reset
import React, { createContext, useContext } from "react";
import { useAllWeeksUnlock, type WeekUnlockResult } from "../hooks/useWeekUnlock";

const WeekContext = createContext<WeekUnlockResult | null>(null);

export const WeekProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const weekUnlock = useAllWeeksUnlock();
  return <WeekContext.Provider value={weekUnlock}>{children}</WeekContext.Provider>;
};

export function useWeekContext(): WeekUnlockResult {
  const ctx = useContext(WeekContext);
  if (!ctx) throw new Error("useWeekContext must be used within <WeekProvider>");
  return ctx;
}
